<div class="header fs-17">
  <p>Restablecer contraseña</p>
  <p (click)="close()" class="cr-pointer">X</p>
</div>

<div class="body">

  <p class="mb-4">
    Ingresa tu correo para recibir las instrucciones que te permitirán restablecer tu contraseña.
  </p>

  <label class="mnf-control mb-4">
    <p class="mnf-control-label cl-primary-3">Correo electrónico</p>
    <input class="mnf-input-form" [ngClass]="{ error: forgotPassEmail.touched && !forgotPassEmail.valid }"
      [formControl]="forgotPassEmail" placeholder="usuario@correo.com" id="email-forgot">
    <span class="msg-error" *ngIf="forgotPassEmail.touched && forgotPassEmail.invalid">Es necesario este campo</span>
  </label>

  <div class="w-100 text-center mt-3">
    <button [disabled]="forgotPassEmail.invalid" mat-button="mat-button" (click)="sendRecoverEmail()">
      Continuar
    </button>
  </div>
</div>